import React from "react";
import "./RoleManagerGroup.css";

function RoleManagerGroup() {
  return (
    <div className="permission-page">
      {/* HEADER */}
      <div className="permission-header">
        <h2 className="permission-title">
          Phân quyền theo nhóm
        </h2>

        <div className="permission-breadcrumb">
          Trang chủ / Quản trị hệ thống /
          <span> Phân quyền theo nhóm</span>
        </div>
      </div>

      {/* TOP FORM */}
      <div className="permission-top-card">
        <div className="permission-top-grid">

          <div className="permission-form-item">
            <label>Nhóm người dùng</label>

            <select>
              <option>Cán bộ nghiệp vụ</option>
            </select>
          </div>

          <div className="permission-form-item">
            <label>Mô tả</label>

            <input
              type="text"
              value="Nhóm cán bộ nghiệp vụ nhập liệu, xử lý dữ liệu"
              readOnly
            />
          </div>

          <div className="permission-form-item">
            <label>Trạng thái</label>

            <div className="permission-status">
              Hoạt động
            </div>
          </div>

          <div className="permission-form-item">
            <label>Chọn vai trò áp dụng</label>

            <select>
              <option>Cán bộ nghiệp vụ</option>
            </select>
          </div>

          {/* BUTTON */}
          <div className="permission-btn-group">
            <button className="permission-btn-back">
              <i className="fa-solid fa-rotate-left"></i>
              Quay lại
            </button>

            <button className="permission-btn-save">
              <i className="fa-regular fa-floppy-disk"></i>
              Lưu thay đổi
            </button>
          </div>
        </div>
      </div>

      {/* TAB */}
      <div className="permission-tab-wrapper">
        <button className="permission-tab active">
          Phân quyền chức năng
        </button>

        <button className="permission-tab">
          Phân quyền dữ liệu
        </button>
      </div>

      {/* CONTENT */}
      <div className="permission-content">

        {/* LEFT */}
        <div className="permission-left">

          <h3>Danh sách chức năng</h3>

          {/* SEARCH */}
          <div className="permission-search">
            <input
              type="text"
              placeholder="Tìm kiếm chức năng..."
            />

            <i className="fa-solid fa-magnifying-glass"></i>
          </div>

          {/* TREE */}
          <div className="permission-tree">

            <div className="tree-row">
              <i className="fa-solid fa-caret-down"></i>

              <input type="checkbox" defaultChecked />

              <span>Tất cả chức năng</span>
            </div>

            <div className="tree-child">

              <div className="tree-row">
                <i className="fa-solid fa-caret-down"></i>

                <input type="checkbox" defaultChecked />

                <span>Dashboard</span>
              </div>

              <div className="tree-sub">

                <div className="tree-row">
                  <input type="checkbox" defaultChecked />
                  <span>Tổng quan</span>
                </div>

                <div className="tree-row">
                  <input type="checkbox" defaultChecked />
                  <span>Thống kê</span>
                </div>

              </div>

              <div className="tree-row">
                <i className="fa-solid fa-caret-down"></i>

                <input type="checkbox" defaultChecked />

                <span>Doanh nghiệp</span>
              </div>

              <div className="tree-sub">

                <div className="tree-row">
                  <input type="checkbox" defaultChecked />
                  <span>Danh sách doanh nghiệp</span>
                </div>

                <div className="tree-row">
                  <input type="checkbox" defaultChecked />
                  <span>Thêm doanh nghiệp</span>
                </div>

                <div className="tree-row">
                  <input type="checkbox" defaultChecked />
                  <span>Cập nhật doanh nghiệp</span>
                </div>

                <div className="tree-row">
                  <input type="checkbox" defaultChecked />
                  <span>Xóa doanh nghiệp</span>
                </div>

                <div className="tree-row">
                  <input type="checkbox" defaultChecked />
                  <span>Xem chi tiết doanh nghiệp</span>
                </div>

              </div>

              <div className="tree-row">
                <i className="fa-solid fa-caret-right"></i>
                <span>Báo cáo</span>
              </div>

              <div className="tree-row">
                <i className="fa-solid fa-caret-right"></i>
                <span>Kê khai</span>
              </div>

              <div className="tree-row">
                <i className="fa-solid fa-caret-right"></i>
                <span>Quản lý dữ liệu</span>
              </div>

              <div className="tree-row">
                <i className="fa-solid fa-caret-right"></i>
                <span>Quản trị hệ thống</span>
              </div>

            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="permission-right">

          <div className="permission-table-top">

            <h3>Ma trận phân quyền</h3>

            <div className="permission-check-group">

              <label>
                <input type="checkbox" defaultChecked />
                Toàn quyền
              </label>

              <label>
                <input type="checkbox" defaultChecked />
                Có quyền
              </label>

              <label>
                <input type="checkbox" />
                Không có quyền
              </label>

              <label>
                <input type="checkbox" />
                Kế thừa
              </label>

            </div>
          </div>

          {/* TABLE */}
          <div className="permission-table-wrapper">

            <table className="permission-table">

              <thead>

                <tr>
                  <th rowSpan="2" className="function-col">
                    Chức năng
                  </th>

                  <th colSpan="7">
                    Quyền hạn
                  </th>
                </tr>

                <tr>
                  <th>Xem</th>
                  <th>Thêm</th>
                  <th>Sửa</th>
                  <th>Xóa</th>
                  <th>Xuất dữ liệu</th>
                  <th>In</th>
                  <th>Duyệt</th>
                </tr>

              </thead>

              <tbody>

                <tr className="main-row">
                  <td>Dashboard</td>

                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td className="sub-row">
                    Tổng quan
                  </td>

                  <td><input type="checkbox" defaultChecked /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                </tr>

                <tr>
                  <td className="sub-row">
                    Thống kê
                  </td>

                  <td><input type="checkbox" defaultChecked /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                </tr>

                <tr className="main-row">
                  <td>Doanh nghiệp</td>

                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td className="sub-row">
                    Danh sách doanh nghiệp
                  </td>

                  <td><input type="checkbox" defaultChecked /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" defaultChecked /></td>
                  <td><input type="checkbox" defaultChecked /></td>
                  <td><input type="checkbox" /></td>
                </tr>

                <tr>
                  <td className="sub-row">
                    Thêm doanh nghiệp
                  </td>

                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" defaultChecked /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                </tr>

                <tr>
                  <td className="sub-row">
                    Cập nhật doanh nghiệp
                  </td>

                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" defaultChecked /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                </tr>

                <tr>
                  <td className="sub-row">
                    Xóa doanh nghiệp
                  </td>

                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" defaultChecked /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                  <td><input type="checkbox" /></td>
                </tr>

              </tbody>

            </table>

          </div>

          <div className="permission-note">
            Ghi chú: Quyền được kế thừa từ nhóm cha (nếu có)
            sẽ hiển thị màu xám.
          </div>

        </div>

      </div>
    </div>
  );
}

export default RoleManagerGroup;